import { z } from "zod";
import { assertEpochMs, toEpochMs } from "@bbb/utils";
export const EpochMsSchema = z
    .number()
    .superRefine((v, ctx) => {
    if (!Number.isSafeInteger(v)) {
        ctx.addIssue({
            code: "custom",
            message: "TimestampInputSchema must be a safe integer (ms).",
        });
        return;
    }
    try {
        assertEpochMs(v);
    }
    catch (e) {
        const message = e instanceof Error ? e.message : "Invalid timestamp.";
        ctx.addIssue({
            code: "custom",
            message,
        });
    }
})
    .transform((v) => v);
export const IsoUtcZSchema = z.iso
    .datetime({ offset: true })
    .refine((s) => s.endsWith("Z"), {
    message: "Only UTC timezone is supported.",
});
export const TimestampInputSchema = z.union([
    EpochMsSchema, // ms
]);
// Normalize to EpochMs
export const TimestampSchema = z.preprocess((v) => {
    if (v == undefined)
        return undefined;
    try {
        if (typeof v === "string" ||
            typeof v === "number" ||
            v instanceof Date) {
            return toEpochMs(v);
        }
        return v;
    }
    catch {
        return v;
    }
}, EpochMsSchema);
